import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import AuthenticationFactorsCard from 'Views/Page/Content/Templates/SettingsTemplate/Content/AuthenticationFactorTemplate/AuthenticationFactorsCard';

const AuthenticationFactorListPicker = (props) => {
  const { pageContentResource } = usePageContentContext();

  return pickFunction(pageContentResource, {
    [fr.relationships.authenticationFactor.name]: () => {
      return (
        <AuthenticationFactorsCard {...props} />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default AuthenticationFactorListPicker;
